import React from 'react';
import { Heading, Flex, FormikField, rem, Dropdown } from '@feast-it/pesto';

const HearingAboutFeastIt = () => {
  return (
    <Flex flexDirection="column" alignItems="center">
      <Heading
        textAlign="center"
        mb={{ _: 2, m: 4 }}
        color="blueDark"
        fontSize={{ _: 'headingExtraLargeMobile', m: 'headingLargeMobile' }}
        lineHeight={{
          _: 'headingExtraLargeMobile',
          m: 'headingLargeMobile',
        }}
        fontWeight={500}
      >
        How did you hear about us?
      </Heading>

      <FormikField
        as={Dropdown}
        width={{ _: '100%', l: rem(620) }}
        fontFamily="body"
        color="blueDark"
        options={[
          {
            label: 'Social Media (Facebook, Instagram, LinkedIn etc..)',
            value: 'Organic Social Media',
          },
          {
            label: 'An advert on social media',
            value: 'Facebook Ads',
          },
          {
            label: 'Search engine (Google, Bing etc..)',
            value: 'Organic_Search',
          },
          {
            label: 'An advert on Google',
            value: 'Google Ads',
          },
          {
            label: 'Recommended by client',
            value: 'Client Referral',
          },
          {
            label: 'Recommended by supplier',
            value: 'Supplier Referral',
          },
          {
            label: 'Togather contacted me',
            value: 'Togather Contacted Me',
          },
          {
            label: 'Other',
            value: 'Other',
          },
        ]}
        size="m"
        mt={rem(52)}
        name="supplier.source"
        placeholder="Select an option"
      />
    </Flex>
  );
};

export default HearingAboutFeastIt;
